import React, { useEffect, useState } from 'react';
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import SolidGauge from "highcharts-solid-gauge";
import { toDisplayTimeString } from '../../helpers/moment-ex';
import { VIEW_PLAN, VIEW_CREW, VIEW_EG } from '../../constants';
import Highcharts from 'highcharts';
import { Unit } from '../../helpers/unit';

HighchartsMore(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);

const DonutView = (props) => {
    const { donutData, summary, tab, params = null } = props
    const options = {
        titleColor: '#ffffff',
        backgroundColor: '#002651',
        primaryColor: '#0051BD',
        secondaryColor: '#ffffff'
    }

    const isRegionId = params.hasOwnProperty("regionId") && params.regionId ? true : false;

    const unit = Unit.getInstance();
    const regioncompleted = unit.toArea(summary.region.completed, 2);
    const regiontotal = unit.toArea(summary.region.total, 2);

    const workedPercent = regioncompleted > 0 && regiontotal > 0 ? unit.toFixedOf((parseFloat(regioncompleted) / parseFloat(regiontotal)) * 100, 2) : 0;

    const [config, setConfig] = useState(
        {
            credits: {
                enabled: false
            },

            chart: {
                type: 'solidgauge',
                height: '60%',
                backgroundColor: options.backgroundColor,
            },

            title: {
                text: '<div><span style="font-size:1.5em; font-weight: bold">0%</span><br>' +
                    '<span>Loading...</span>',
                verticalAlign: 'middle',
                floating: true,
                useHTML: Boolean,
                style: { "color": options.titleColor, "fontSize": "0.7em", "text-align": "center" },
                y: -10
            },

            tooltip: {
                enabled: false,
                pointFormatter: function () {
                    var s = 'Planned Work: <b>' + this.radiusValues[0] + '</b><br>' +
                        'Planned Utilization: <b>' + this.radiusValues[1] + '</b><br>' +
                        'Actual Work: <b>' + this.radiusValues[2] + '</b><br>' +
                        'Actual Utilization: <b>' + this.radiusValues[3] + '</b><br>';
                    return s;
                },
                shared: true,
                shadow: false,
                positioner: function (labelWidth, labelHeight, point) {
                    return {
                        x: 1,
                        y: (this.chart.plotHeight - labelHeight) + 22
                    }
                }
            },

            pane: {
                startAngle: 0,
                endAngle: 360,
                background: [{
                    outerRadius: '95%',
                    innerRadius: '94%',
                    backgroundColor: '#0051BD',
                    borderWidth: 0
                }, {
                    outerRadius: '60%',
                    innerRadius: '61%',
                    backgroundColor: options.secondaryColor,
                    borderWidth: 0
                }]
            },

            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                tickPositions: []
            },

            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        enabled: false
                    },
                    linecap: 'round',
                    stickyTracking: false,
                    rounded: true
                }
            },

            series: []
        }
    )

    const [regionconfig, setRegionConfig] = useState(
        {
            credits: {
                enabled: false
            },

            chart: {
                type: 'solidgauge',
                height: '60%',
                backgroundColor: options.backgroundColor,
            },

            title: {
                text: '<div><span style="font-size:1.5em; font-weight: bold">0%</span><br>' +
                    '<span>Loading...</span>',
                verticalAlign: 'middle',
                floating: true,
                useHTML: Boolean,
                style: { "color": options.titleColor, "fontSize": "0.7em", "text-align": "center" },
                y: -10
            },

            pane: {
                startAngle: 0,
                endAngle: 360,
                background: [{ 
                    outerRadius: '112%',
                    innerRadius: '88%',
                    backgroundColor: Highcharts.color(Highcharts.getOptions().colors[0])
                        .setOpacity(0.3)
                        .get(),
                    borderWidth: 0
                }]
            },

            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                tickPositions: []
            },

            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        enabled: false
                    },
                    linecap: 'round',
                    stickyTracking: false,
                    rounded: true
                }
            },

            series: [{
                name: 'Move',
                data: [{
                    color: Highcharts.getOptions().colors[0],
                    radius: '112%',
                    innerRadius: '88%',
                    y: 80
                }]
            }]
        }
    )

    useEffect(() => {
        if (isRegionId) bindRegionDonutData(donutData);
        else bindDonutData(donutData);

    }, [donutData, isRegionId]);

    useEffect(() => {
        if (isRegionId) {
            setRegionConfig({
                ...regionconfig,
                series: []
            })
        } else {
            setConfig({
                ...config,
                series: []
            })
        }
    }, [tab]);

    const bindDonutData = (data) => {
        let seriesValue = [];
        let titleText = [];

        if (summary && !summary.isRequesting) {
            if (data.hasOwnProperty('planned_work_percentage') && data.planned_work_percentage > 0) {
                seriesValue.push({
                    name: 'Planned Work',
                    borderWidth: 1,
                    borderColor: options.primaryColor,
                    data: [{
                        color: options.backgroundColor,
                        radius: '102%',
                        innerRadius: '88%',
                        y: data.planned_work_percentage
                    }]
                });
            }

            if (data.hasOwnProperty('planned_utilization_percentage') && data.planned_utilization_percentage > 0) {
                seriesValue.push({
                    name: 'Planned Utilization',
                    data: [{
                        color: options.primaryColor,
                        radius: '102%',
                        innerRadius: '88%',
                        y: data.planned_utilization_percentage
                    }]
                });
            }

            if (data.hasOwnProperty('actual_work_percentage') && data.actual_work_percentage > 0) {
                seriesValue.push({
                    name: 'Actual Work',
                    borderWidth: 1,
                    borderColor: options.secondaryColor,
                    data: [{
                        color: '#002651',
                        radius: '67%',
                        innerRadius: '53%',
                        y: data.actual_work_percentage
                    }]
                });
            }

            if (data.hasOwnProperty('actual_utilization_percentage') && data.actual_utilization_percentage > 0) {
                seriesValue.push({
                    name: 'Actual Utilization',
                    data: [{
                        color: options.secondaryColor,
                        radius: '67%',
                        innerRadius: '53%',
                        y: data.actual_utilization_percentage
                    }]
                });
            }


            if (data.hasOwnProperty('utilization')) {
                titleText = `<div><span style="font-size:1.5em; font-weight: bold">${Math.round(data.utilization)}%</span><br><span>Utilization</span></div>`;
                if (data.view === VIEW_PLAN) titleText += `<span>Average of ${data.crew_count} ${data.crew_count === 1 ? ' Crew' : ' Crews'} + '</span>`
                else if (data.view === VIEW_CREW) titleText += `<span>Average of ${data.equipment_group_count + (data.equipment_group_count === 1 ? ' Vehicle' : ' Vehicles')} </span>`;
                else if (data.view === VIEW_EG) titleText += `<span></span>`;
            }

            setConfig({
                ...config,
                series: seriesValue,
                title: {
                    ...config.title,
                    text: titleText,
                }
            });
        }
        else {
            setConfig({
                ...config,
                title: {
                    text: '<div><span style="font-size:1.5em; font-weight: bold">0%</span><br>' +
                        '<span>Loading...</span>',
                    verticalAlign: 'middle',
                    floating: true,
                    useHTML: Boolean,
                    style: { "color": options.titleColor, "fontSize": "0.7em", "text-align": "center" },
                    y: -10
                },
                series: []
            })
        }
    }

    const bindRegionDonutData = (data) => {
        let seriesValue = [];
        let titleText = [];

        if (summary && !summary.isRequesting) {
            if (isRegionId && workedPercent > 0) {
                seriesValue.push({
                    name: 'Completed percentage',
                    data: [{
                        color: options.secondaryColor,
                        radius: '112%',
                        innerRadius: '88%',
                        y: workedPercent
                    }]
                });
            }

            if (isRegionId) {
                titleText = `<div><span style="font-size:1.5em; font-weight: bold">${workedPercent} %</span><br><span>Completed</span></div>`;
            }

            setRegionConfig({
                ...regionconfig,
                series: seriesValue,
                title: {
                    ...regionconfig.title,
                    text: titleText,
                }
            });
        }
        else {
            setRegionConfig({
                ...regionconfig,
                title: {
                    text: '<div><span style="font-size:1.5em; font-weight: bold">0%</span><br>' +
                        '<span>Loading...</span>',
                    verticalAlign: 'middle',
                    floating: true,
                    useHTML: Boolean,
                    style: { "color": options.titleColor, "fontSize": "0.7em", "text-align": "center" },
                    y: -10
                },
                series: []
            })
        }
    }

    const d = donutData;

    return (
        <div>
            <ReactHighcharts highcharts={Highcharts} config={isRegionId ? regionconfig : config} options={isRegionId ? regionconfig : config}></ReactHighcharts>
            {
                params && (!isRegionId) && <div className="disp-dnut-data mx-auto">
                    <div className="d-flex planned-row planned">
                        <div className="first-cell">Planned Work</div>
                        <div className="second-cell">:</div>
                        <div className="last-cell">{summary && !summary.isRequesting ? toDisplayTimeString(d.planned_work) : 0}</div>
                    </div>
                    <div className="d-flex planned-row planned-utilization">
                        <div className="first-cell">Planned Utilization</div>
                        <div className="second-cell">:</div>
                        <div className="last-cell">{summary && !summary.isRequesting ? toDisplayTimeString(d.planned_utilization) : 0}</div>
                    </div>
                    <div className="d-flex planned-row actual">
                        <div className="first-cell">Actual Work</div>
                        <div className="second-cell">:</div>
                        <div className="last-cell">{summary && !summary.isRequesting ? toDisplayTimeString(d.actual_work) : 0}</div>
                    </div>
                    <div className="d-flex planned-row actual-utilization">
                        <div className="first-cell">Actual Utilization</div>
                        <div className="second-cell">:</div>
                        <div className="last-cell">{summary && !summary.isRequesting ? toDisplayTimeString(d.actual_utilization) : 0}</div>
                    </div>
                </div>
            }
        </div>
    );
}

export default DonutView;